import { useState } from 'react';

export const getLocalStorageItem = <T>(key: string, defaultValue?: T) => {
  try {
    const item = window.localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    // console.error(error);
    return defaultValue;
  }
};

export const setLocalStorageItem = <T>(key: string, value: T) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // console.error(error);
  }
};

export const removeLocalStorageItem = (key: string) => {
  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    // console.error(error);
  }
};

const useLocalStorage = <T>(
  key: string,
  initialValue: T
): [T, (value: T | ((val: T) => T)) => void] => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    return getLocalStorageItem<T>(key, initialValue);
  });

  const setValue: (value: T | ((val: T) => T)) => void = value => {
    try {
      // Allow value to be a function to mirror useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;

      setStoredValue(valueToStore);
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      // console.error(error);
    }
  };

  return [storedValue, setValue];
};

export default useLocalStorage;
